export const gti = ({ routed, unrouted }) => [{
  type: 'div',
  attrs: [{ name: 'class', value: 'maui-mf-root' }],
  routes: [
    {
      type: 'div',
      attrs: [{
        name: 'class',
        value: 'maui-mf-root__shell'
      }],
      routes: [
        {
          type: 'application',
          name: '@maui/app-gti/Shell'
        },
        {
          type: 'application',
          name: '@maui/app-gti/FeatureToggler',
        }
      ]
    },
    {
      type: 'div',
      attrs: [{
        name: 'class',
        value: 'maui-mf-root__shell-content'
      }],
      routes: [
        {
          type: 'route',
          path: '/',
          routes: [
            {
              type: 'div',
              attrs: [{
                name: 'class',
                value: 'maui-mf-root__main'
              }],
              routes: routed,
            },
          ]
        },
        {
          type: 'route',
          path: '/',
          exact: true,
          routes: [
            {
              type: 'footer',
              attrs: [{
                name: 'class',
                value: 'maui-mf-root__footer'
              }],
              routes: [{
                type: 'application',
                name: '@maui/app-gti/Footer',
              }]
            }
          ]
        }
      ]
    },
    {
      type: 'div',
      attrs: [{
        name: 'class',
        value: 'maui-mf-root__unrouted'
      }],
      routes: unrouted,
    }
  ]
}]
